import { render, staticRenderFns } from "./NavigationMenu.vue?vue&type=template&id=a45b35d2&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=ts"
export * from "./NavigationMenu.vue?vue&type=script&lang=ts"
import style0 from "./NavigationMenu.vue?vue&type=style&index=0&id=a45b35d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45b35d2",
  null
  
)

export default component.exports